import { Component, OnInit, ViewChild } from '@angular/core';
import { CSVDataService } from '@app/export/CSVDataService';
import { AdminService } from '@app/services/admin/admin.service';
import { ReportService } from '@app/services/Reports/Report.service';
import { MessageService, SelectItem } from 'primeng/api';


@Component({
  selector: 'app-admin-connect-accesses-and-roles',
  templateUrl: './admin-connect-accesses-and-roles.component.html'
})
export class AdminConnectAccessesAndRolesComponent implements OnInit {

  @ViewChild('dt') table;
  @ViewChild('globalfilter') globalfilter;
  records: any[] = [];
  cols: any[];
  roles: SelectItem[] = [];
  types: SelectItem[] = [];
  formdata;
  display = false;
  loading = false;

  constructor(
    private reportService: ReportService,
    private adminService: AdminService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.cols = [
      { field: 'accessControlId', header: 'Id' },
      { field: 'committeeAbbreviation', header: 'Förkortning' },
      { field: 'committeeName', header: 'Namn' },
      { field: 'committeeSort', header: 'Sortering' },
      { field: 'institutionTypeName', header: 'Institutionstyp' },
      { field: 'institutionShortName', header: 'Institution' },
      { field: 'officeAbbreviation', header: 'Förkortning' },
      { field: 'officeName', header: 'Namn' },
      { field: 'officeSort', header: 'Sortering' },
      { field: 'officeEmail', header: 'Epost' },
      { field: 'officeIsactive', header: 'Aktiv' },
      { field: 'officeTypeId', header: 'Typ' },
      { field: 'officeTypeAbbreviation', header: 'Förkortning' },
      { field: 'officeTypeName', header: 'Namn' },
      { field: 'officeTypeSort', header: 'Sortering' },
      { field: 'memberOfficeCount', header: 'Antal för MEMOFF_MEM' },
      { field: 'roleDescription', header: 'Behörighetsroll' }
    ];

    this.getReportList();
    this.getRoles();
  }

  getReportList() {
    this.loading = true;
    this.reportService.GetOfficeList().subscribe(resp => {
      if (resp) {
        this.records = resp;
        this.loading = false;
      }
    });
  }

  getRoles() {
    this.formdata;
    this.adminService.GetRoles().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.description, value: d.id
          };
          this.roles.push(record);

        });
        const emptyrecord = {
          label: '', value: null
        };
        this.roles.unshift(emptyrecord);
        this.getOfficeTypes();
      }
    });
  }

  getOfficeTypes() {
    this.adminService.GetOfficeTypes().subscribe(data => {
      if (data) {
        data.forEach(d => {
          const record = {
            label: d.name, value: d.id
          };
          this.types.push(record);
        });
        const emptyrecord = {
          label: '', value: null
        };
        this.types.unshift(emptyrecord);
      }
    });
  }

  exportToCSV() {
    const excelrecords: any[] = [];
    this.records.forEach(r => {
      const row = {
        accessControlId: r.accessControlId,
        committeeAbbreviation: r.committeeAbbreviation,
        committeeName: r.committeeName,
        committeeSort: r.committeeSort,
        institutionTypeName: r.institutionTypeName,
        institutionShortName: r.institutionShortName,
        officeAbbreviation: r.officeAbbreviation,
        officeName: r.officeName,
        officeSort: r.officeSort,
        officeEmail: r.officeEmail,
        officeIsactive: r.officeIsactive,
        officeTypeId: r.officeTypeId,
        officeTypeAbbreviation: r.officeTypeAbbreviation,
        officeTypeName: r.officeTypeName,
        officeTypeSort: r.officeTypeSort,
        memberOfficeCount: r.memberOfficeCount,
        roleDescription: r.roleDescription
      }
      excelrecords.push(row);
    });
    let firstrow = 'Utskott Förkortning;Utskott Namn;Utskott Sortering;Institutionstyp;Institution;Ämbete Förkortning;Ämbete Namn;Ämbete Sortering;Ämbete Epost;Aktiv;ÄmbetsTyp;Ämbetstyp Förkortning;Ämbetstyp Namn;Ämbetstyp Sortering;Antal för MEMOFF_MEM;Behörighetsroll';
    const filnamn = 'OF_ListaUppdrag';
    CSVDataService.exportToCsv(filnamn + '.csv', excelrecords, firstrow);
  }

  resetFilter() {
    this.table.reset();
    this.table.clearState();
    this.globalfilter.nativeElement.value = null;
  }

  edit(formdata) {
    this.formdata = formdata;
    this.display = true;
  }

  saveAccessAndRoleConnection(evt) {
    this.display = false;
    this.adminService.AddSystemPermissionsToAuthorizationRole(evt).subscribe(function (_) {

    });

    this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Behörighetsroll sparad.' });

  }

  cancelEdit() {
    this.display = false;
  }
}
